// extracted by mini-css-extract-plugin
module.exports = {"navigation-link":"_02712f2b3b--navigation-link--_7w1k","active-link":"_02712f2b3b--active-link--YSShk"};